import { Component } from '@angular/core';
import { LoginService } from '../login.service';

@Component({
  selector: 'cms-header',
  templateUrl: './header.component.html',
  styleUrls: [
    './header.component.scss'
  ]
})

export class HeaderComponent {
  constructor(private loginService: LoginService) {}

  logout(){
    this.loginService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts